import { CARD_TYPES } from "../../Card/constants";
import DisplayPolicy from "./DisplayPolicy";
import { DEFAULT_MAP_KEY } from "../constants";

/**
 * @class MediumDensityPolicy
 * @extends DisplayPolicy
 */
class MediumDensityPolicy extends DisplayPolicy {
    constructor() {
        super();
        this.policyName = "MediumDensityPolicy";
    }

    buildCardTypesMap() {
        this.cardTypesMap = new Map();
        this.cardTypesMap.set(DEFAULT_MAP_KEY, CARD_TYPES.TYPE_DEFAULT);
    }
}

export default MediumDensityPolicy;
